/**
 * O perfil guarda 'Nº do Documento de Identificação' sem o tipo — pode ser RG, CNH, RNE…
 * Pelo órgão emissor dá pra saber se é RG: RG é emitido pela Secretaria de Segurança/Polícia
 * Civil/Instituto de Identificação do estado (no RJ, também pelo DETRAN). Órgão desconhecido
 * conta como 'não é RG' — melhor pedir do que mandar número errado pro Cliente.
 *
 * Mesma regra nas functions: functions/src/si/documentoIdentidade.ts (verificarDadosEmailCliente) — mudar nos dois.
 */
const PREFIXOS_ORGAO_RG = [
  'SSP',
  'SESP',
  'SDS',
  'SEDS',
  'SESDEC',
  'SESEG',
  'SEJUSP',
  'SEJSP',
  'SEGUP',
  'SJS',
  'SJTC',
  'PC',
  'IFP',
  'IGP',
  'IIRGD',
  'IIPR',
  'ITEP',
  'DGPC',
  'POLITEC',
  'SPTC',
];
const EXPRESSOES_ORGAO_RG = ['POLICIA CIVIL', 'INSTITUTO DE IDENTIFICACAO', 'SECRETARIA DE SEGURANCA'];

function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim();
}

export function orgaoEmissorCompativelComRg(orgao: string | null | undefined, uf?: string | null): boolean {
  if (!orgao) return false;
  const texto = normalizar(orgao);
  if (EXPRESSOES_ORGAO_RG.some((expressao) => texto.includes(expressao))) return true;
  const palavras = texto.split(' ');
  // DETRAN só emite RG no Rio de Janeiro (fora de lá é CNH).
  if (palavras.includes('DETRAN')) return palavras.includes('RJ') || normalizar(uf ?? '') === 'RJ';
  return palavras.some((palavra) => PREFIXOS_ORGAO_RG.some((prefixo) => palavra.startsWith(prefixo)));
}
